import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var AiIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M16.892 4.847l.311 1.359a5.264 5.264 0 001.121 2.229 4.162 4.162 0 001.994 1.254l1.215.348c.218.07.405.21.53.418.124.21.186.453.186.697 0 .244-.062.487-.187.696a.938.938 0 01-.53.418l-1.214.349c-.748.209-1.433.662-1.994 1.254a4.933 4.933 0 00-1.12 2.229l-.312 1.358c-.063.279-.25.523-.468.697-.218.14-.498.209-.778.104a1.3 1.3 0 01-.436-.313 1.028 1.028 0 01-.25-.488l-.342-1.637a5.263 5.263 0 00-1.122-2.23 4.162 4.162 0 00-1.993-1.253H10.35s-.249-.104-.342-.209a1.35 1.35 0 01-.25-.348c-.062-.14-.093-.279-.124-.418 0-.14 0-.279.031-.453s.125-.348.25-.488c.124-.14.28-.244.435-.313l1.215-.349c.748-.209 1.433-.661 1.994-1.253a4.932 4.932 0 001.121-2.23l.343-1.358s.093-.279.155-.383c.094-.105.187-.21.28-.279.125-.07.25-.14.375-.14h.373c.156.07.28.14.405.28.125.139.187.278.25.452h.03zM6.348 15.642l.207.745c.115.465.345.86.69 1.209a2.64 2.64 0 001.172.698l.758.209c.161.046.3.14.368.302a.57.57 0 01.07.465c-.024.093-.093.186-.162.28a.551.551 0 01-.276.162l-.758.21c-.437.116-.85.349-1.195.674a2.604 2.604 0 00-.667 1.21l-.207.767a.541.541 0 01-.299.372.548.548 0 01-.46.07.55.55 0 01-.275-.163.56.56 0 01-.161-.279l-.207-.767c-.115-.466-.368-.861-.69-1.21a2.558 2.558 0 00-1.195-.674l-.736-.21s-.183-.023-.252-.07c-.07-.046-.161-.092-.207-.186a.864.864 0 01-.115-.255v-.28a.432.432 0 01.16-.279.67.67 0 01.276-.162l.736-.21c.46-.116.85-.372 1.195-.697.322-.326.575-.745.69-1.21l.207-.744a.541.541 0 01.299-.372.548.548 0 01.46-.07c.137 0 .252.047.344.14.092.07.184.186.23.302v.023zm.564-14.363l.163.61a2.2 2.2 0 00.582.94c.28.258.605.446.955.517l.605.164s.14.047.21.094a.543.543 0 01.162.165c.047.07.047.14.047.21 0 .071 0 .165-.047.236a.342.342 0 01-.14.211.55.55 0 01-.209.141l-.605.165a2.12 2.12 0 00-.954.587c-.256.282-.466.61-.582.963l-.163.61a.6.6 0 01-.233.306.425.425 0 01-.372.047.482.482 0 01-.233-.141.555.555 0 01-.14-.212l-.163-.61a2.095 2.095 0 00-.558-.987 1.997 1.997 0 00-.955-.563l-.605-.165s-.186-.094-.256-.188a.475.475 0 01-.093-.305.47.47 0 01.093-.305.488.488 0 01.256-.188l.582-.235c.373-.094.698-.282.978-.54.256-.259.465-.611.535-.987l.163-.61s.163-.189.28-.212a.45.45 0 01.348 0c.07 0 .14.047.21.094.07.047.116.117.14.188z"
                    })
                })
            })
        ]
    });
};
AiIcon.isCarinaIcon = true;
export default AiIcon;
